var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Images--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--photo-3--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.67,
    y: 126.37,
    width: 215.91,
    height: 211.41,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.67,
    y: 126.37,
    width: 215.91,
    height: 211.41,
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.23,
    y: 133.13,
    width: 204.81,
    height: 204.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.58 334.8 325.58 337.78 216.77 337.78 240.29 314.28 272.67 281.88 325.58 334.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.58 334.8 325.58 337.78 216.77 337.78 240.29 314.28 272.67 281.88 325.58 334.8",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.67 337.78 109.67 317.46 176.57 250.56 263.79 337.78 109.67 337.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.67 337.78 109.67 317.46 176.57 250.56 263.79 337.78 109.67 337.78",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.23,
    cy: 194.22,
    r: 33.06,
    transform: "translate(20.95 413.07) rotate(-80.78)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.23,
    cy: 194.22,
    r: 33.06,
    transform: "translate(20.95 413.07) rotate(-80.78)",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--photo-2--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.16,
    y: 129.96,
    width: 211.41,
    height: 215.91,
    transform: "translate(7.74 484.36) rotate(-84.42)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.16,
    y: 129.89,
    width: 211.41,
    height: 215.91,
    transform: "translate(7.81 484.3) rotate(-84.42)",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 138.87,
    width: 204.65,
    height: 204.81,
    transform: "translate(4.11 487.08) rotate(-84.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.64,
    y: 134.6,
    width: 1,
    height: 7.18,
    transform: "translate(194.81 491.15) rotate(-84.42)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.09,
    y: 126.2,
    width: 1,
    height: 17.66,
    transform: "translate(181.35 470.45) rotate(-84.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.64,
    y: 134.6,
    width: 1,
    height: 7.18,
    transform: "translate(194.81 491.15) rotate(-84.42)",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.09,
    y: 126.2,
    width: 1,
    height: 17.66,
    transform: "translate(181.35 470.45) rotate(-84.29)",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.31 350.63 368.02 353.6 259.73 343.02 285.42 321.92 320.8 292.82 368.31 350.63",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.31 350.63 368.02 353.6 259.73 343.02 285.42 321.92 320.8 292.82 368.31 350.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.31 350.63 368.02 353.6 259.73 343.02 285.42 321.92 320.8 292.82 368.31 350.63",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.98,
    cy: 203.7,
    r: 33.06,
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.98,
    cy: 203.7,
    r: 33.06,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.98,
    cy: 203.7,
    r: 33.06,
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--photo-1--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.97,
    y: 156.95,
    width: 215.91,
    height: 211.41,
    transform: "translate(-16.72 13.08) rotate(-3.74)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.74,
    y: 163.7,
    width: 204.81,
    height: 204.65,
    transform: "translate(-16.94 13.1) rotate(-3.74)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.97,
    y: 156.95,
    width: 215.91,
    height: 211.41,
    transform: "translate(-16.72 13.08) rotate(-3.74)",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.33 358.14 306.52 361.11 197.95 368.2 219.88 343.22 250.08 308.78 306.33 358.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.33 358.14 306.52 361.11 197.95 368.2 219.88 343.22 250.08 308.78 306.33 358.14",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.07 375.18 89.75 354.91 152.15 283.79 244.86 365.14 91.07 375.18",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.07 375.18 89.75 354.91 152.15 283.79 244.86 365.14 91.07 375.18",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.98,
    cy: 222.58,
    r: 33.06,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.98,
    cy: 222.58,
    r: 33.06,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.63,200.92c.71,1.31,1.3,2.47,1.88,3.73s1.15,2.47,1.7,3.72c1.07,2.5,2.07,5,3,7.65a79.48,79.48,0,0,1,2.32,8l.47,2.06.38,2.09c.14.7.22,1.42.32,2.13l.14,1.08v.71a8.34,8.34,0,0,1,0,1,15.07,15.07,0,0,1-1.3,5.53,34.51,34.51,0,0,1-2.08,4.06,63,63,0,0,1-4.83,6.85,103.72,103.72,0,0,1-11.09,11.77l-4.08-3.66c2.91-4.2,5.8-8.54,8.4-12.84a71.76,71.76,0,0,0,3.49-6.46,23.87,23.87,0,0,0,1.21-3.07,5.86,5.86,0,0,0,.36-2.11h0v-.22l-.19-.86c-.12-.58-.23-1.15-.4-1.73l-.46-1.74-.51-1.75c-.73-2.33-1.54-4.66-2.45-7s-1.87-4.63-2.88-6.92-2.12-4.63-3.14-6.74Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,218.41l-13.61,7.19-3.28,1.74s-.77-2.25-1.86-5.52c-.88-2.61-2-5.86-3.06-9.15-.34-1-.68-2.07-1-3.09-.1-.29-.2-.57-.29-.86-2.94-9,5.22-13.05,10.77-11.89C399.27,198.82,402.1,218.41,402.1,218.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,218.41l-13.61,7.19-3.28,1.74s-.77-2.25-1.86-5.52c-.88-2.61-2-5.86-3.06-9.15-.34-1-.68-2.07-1-3.09-.1-.29-.2-.57-.29-.86-2.94-9,5.22-13.05,10.77-11.89C399.27,198.82,402.1,218.41,402.1,218.41Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.49,225.6l-3.28,1.74s-.77-2.25-1.86-5.52c-.88-2.61-2-5.86-3.06-9.15-.34-1-.68-2.07-1-3.09l7.5-1.47S387.81,220,388.49,225.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.49,225.6l-3.28,1.74s-.77-2.25-1.86-5.52c-.88-2.61-2-5.86-3.06-9.15-.34-1-.68-2.07-1-3.09l7.5-1.47S387.81,220,388.49,225.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.12,256.5l-7,2.33,6.35,6.81s5.53-3.31,4.11-6.44Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.29 265.1 372.79 270.39 378.45 265.64 372.1 258.83 367.29 265.1",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.95 400.73 321.69 400.19 321.01 383.22 328.27 383.76 328.95 400.73",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 407.21 368.11 407.21 362.43 390.33 369.72 390.33 375.4 407.21",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.01 383.23 321.36 391.98 328.63 392.52 328.28 383.77 321.01 383.23",
    style: {
      fill: "#db9792"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.72 390.34 362.43 390.34 365.36 399.04 372.65 399.04 369.72 390.34",
    style: {
      fill: "#db9792"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.28,397.35H361.93s-13-44.72-16.27-67.87c-.7-5-.29-11.6.76-18.76,1.79-12.25,5.41-26.16,8.42-36.54,2.68-9.23,4.89-15.68,4.89-15.68l25.09,1.87c-1.36,18.21-19.38,48.11-18.13,72.82C367.84,356,375.28,397.35,375.28,397.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.28,397.35H361.93s-13-44.72-16.27-67.87c-.7-5-.29-11.6.76-18.76,1.79-12.25,5.41-26.16,8.42-36.54,2.68-9.23,4.89-15.68,4.89-15.68l25.09,1.87c-1.36,18.21-19.38,48.11-18.13,72.82C367.84,356,375.28,397.35,375.28,397.35Z",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,176.22c-1.56,5.2-3.57,14.82-.21,18.72,0,0-2,5.24-11.84,4.26-10.84-1.08-4.64-5.89-4.64-5.89,6.05-.83,6.34-5.23,5.71-9.46Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,168.35c-.06.58-.42,1-.8,1s-.64-.54-.59-1.13.42-1,.8-1S360.51,167.76,360.45,168.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43,168.64a20.6,20.6,0,0,1-3.29,4.72,3.38,3.38,0,0,0,2.74.81Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.69,166.42a.34.34,0,0,1-.3-.17,2.74,2.74,0,0,0-2.08-1.36.36.36,0,0,1-.34-.36.31.31,0,0,1,.31-.33h.05a3.4,3.4,0,0,1,2.65,1.69.35.35,0,0,1-.11.48A.41.41,0,0,1,362.69,166.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.14,406.36H376a.63.63,0,0,1,.62.5l1.44,6.48a1.07,1.07,0,0,1-.83,1.27l-.24,0c-2.85-.05-4.94-.21-8.54-.21-2.21,0-6.78.23-9.84.23s-3.45-3-2.2-3.3c5.61-1.23,7.73-2.92,9.52-4.54A1.83,1.83,0,0,1,367.14,406.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34,398.56l7.94.59a.65.65,0,0,1,.58.55l.95,6.56a1.05,1.05,0,0,1-.88,1.21,1.13,1.13,0,0,1-.26,0c-2.86-.27-7-.74-10.58-1-4.21-.31-7-.46-11.94-.83-3-.22-3.58-3.3-2.32-3.48,5.78-.82,9.58-.5,14.72-3.16A3.38,3.38,0,0,1,321.34,398.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,199.74c-.66,1.13-1.45,2.42-2.18,3.64s-1.53,2.46-2.32,3.67c-1.57,2.43-3.2,4.81-4.89,7.11s-3.45,4.52-5.3,6.59a45.33,45.33,0,0,1-5.18,5,28.51,28.51,0,0,1-4.69.68,27.39,27.39,0,0,1-6-.36,32.27,32.27,0,0,1-8.9-2.94c-.47-.24-.93-.5-1.38-.76l-1.26-.75-3.81,3.92c.54.62.95,1,1.44,1.52a18.55,18.55,0,0,0,1.47,1.3,31.24,31.24,0,0,0,3.15,2.33,32.26,32.26,0,0,0,7.16,3.42,32.59,32.59,0,0,0,7.94,1.57,34.15,34.15,0,0,0,8.14-.47l.83-.15.95-.62a48.15,48.15,0,0,0,7.74-6.43,79.18,79.18,0,0,0,6.36-7.21c2-2.48,3.78-5.05,5.51-7.66.86-1.33,1.69-2.67,2.5-4s1.58-2.66,2.38-4.16Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.59,224l-5.44-4.76L298,226.42s3.87,4.34,8.42,1.61Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.58 216.12 291.69 222.69 297.96 226.42 302.15 219.28 294.58 216.12",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.36,168.3c-1.16,7.14-1.47,11.37-5.46,14.7-6,5-14.55.83-15.55-6.51-.9-6.6,1.14-17.17,8.45-19.33a9.87,9.87,0,0,1,12.56,11.14Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,164.54c5.34,3.74-7.37,17.46-11.89,17.31s-13-12.68-10.22-19.35c-2.33-.94-3.08-1.25-4-3.63-1.72-4.31.35-11.5,10.91-9.48-2.62,1.78-.8,3.19,4.17,2.5-2,2.33,1.28,4.05,6.11,3.05C382.67,159.22,393.44,159.83,388.44,164.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.31,170.51a6.92,6.92,0,0,1-2.86,4.4c-2,1.35-3.76-.25-3.84-2.54-.07-2.05.88-5.23,3.19-5.66a3.09,3.09,0,0,1,3.56,2.53A3.19,3.19,0,0,1,370.31,170.51Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,279.44c-.14,12.12-8.66,25.51-15.06,31.28,1.79-12.25,5.41-26.16,8.42-36.54C356.71,273.8,359.92,277.35,361.48,279.44Z",
    style: {
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73,407.64a2.17,2.17,0,0,1-1.4-.38,1,1,0,0,1-.36-.91.56.56,0,0,1,.29-.49c.82-.4,3.16,1,3.43,1.2a.18.18,0,0,1,.07.17.16.16,0,0,1-.13.14A7.64,7.64,0,0,1,364.73,407.64Zm-1.08-1.51a.45.45,0,0,0-.23,0,.23.23,0,0,0-.11.2.72.72,0,0,0,.24.63,3.49,3.49,0,0,0,2.58.13,7.15,7.15,0,0,0-2.48-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.59,407.38h-.08c-.75-.41-2.21-2-2.06-2.82a.56.56,0,0,1,.55-.45.9.9,0,0,1,.74.22c.84.69,1,2.79,1,2.88a.21.21,0,0,1-.08.16Zm-1.47-3h-.07c-.23,0-.25.13-.26.17-.09.48.84,1.69,1.59,2.26a4.2,4.2,0,0,0-.86-2.28.57.57,0,0,0-.4-.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85,399.63a3.48,3.48,0,0,1-2.36-.6,1,1,0,0,1-.26-.86.54.54,0,0,1,.32-.44c.92-.42,3.73,1.27,4.05,1.47a.18.18,0,0,1,.08.18.19.19,0,0,1-.15.14A13.54,13.54,0,0,1,318.85,399.63ZM316.93,398a.59.59,0,0,0-.23.05.21.21,0,0,0-.13.17.63.63,0,0,0,.17.57c.42.43,1.61.59,3.23.44A8.66,8.66,0,0,0,316.93,398Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,399.52h-.09c-.84-.46-2.46-2.16-2.27-3,.05-.19.2-.42.68-.44a1.33,1.33,0,0,1,.93.37,5,5,0,0,1,.92,2.88.18.18,0,0,1-.08.15Zm-1.64-3.08h0c-.32,0-.34.13-.35.17-.12.48,1,1.81,1.82,2.41a4,4,0,0,0-.79-2.31A.92.92,0,0,0,318.87,396.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,257.48s-31.48,47.62-32.34,69.84c-.89,23.11,5.15,62.77,5.15,62.77l12.31.92s1.43-37.72,3.66-60.32c2.43-24.63,38-52.08,39.4-71.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,257.48s-31.48,47.62-32.34,69.84c-.89,23.11,5.15,62.77,5.15,62.77l12.31.92s1.43-37.72,3.66-60.32c2.43-24.63,38-52.08,39.4-71.11Z",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.57 397.64 377.02 397.64 377.02 392.94 357.52 392.64 359.57 397.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.29 390.16 333.38 391.47 333.74 386.73 314.61 385.02 316.29 390.16",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,203.09c-.52,6.94-8.74,20.47-8.74,20.47l-18.61-9.78s6.3-10.13,13.19-16.16S360.14,195.46,359.57,203.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,203.09c-.52,6.94-8.74,20.47-8.74,20.47l-18.61-9.78s6.3-10.13,13.19-16.16S360.14,195.46,359.57,203.09Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.13,195.14c.5-1-.22-4.56-.22-4.56s15.47-2.08,21-.11c3,1.06.36,6.41.36,6.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.13,195.14c.5-1-.22-4.56-.22-4.56s15.47-2.08,21-.11c3,1.06.36,6.41.36,6.41Z",
    style: {
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81,260.37,346,257.48A176,176,0,0,1,344.67,228c.16-3.54.44-6.8.78-9.78,1.8-15.59,5.6-23.51,5.6-23.51a72.93,72.93,0,0,1,11.32-1.19,142.62,142.62,0,0,1,16.52,1.23,89,89,0,0,1,11.77,2.32C382.81,224.75,385.52,254.42,384.81,260.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.81,260.37,346,257.48A176,176,0,0,1,344.67,228c.16-3.54.44-6.8.78-9.78,1.8-15.59,5.6-23.51,5.6-23.51a72.93,72.93,0,0,1,11.32-1.19,142.62,142.62,0,0,1,16.52,1.23,89,89,0,0,1,11.77,2.32C382.81,224.75,385.52,254.42,384.81,260.37Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no_photo.ddfb38be2dfd7ce818b089f5ea628006.svg";
export { ForwardRef as ReactComponent };